/* eslint-disable no-use-before-define */
import React from 'react'
import {
    getState,
    Status,
    getBrand,
    ajax,
    evalJson,
    arrayFrom,
    parseDate,
    clearObject,
    getOwaTcdaoContext,
} from '../twd/twd'

const Last = getState('order-ticket-bond-info.last', {
    ts: 0,
    bondInfo: {},
    hasBondInfo: false,
    bondInfoStatus: Status.NULL,
    isBondRestricted: false,
})


const Last30Days = 30 * 24 * 60 * 60 * 1000

export const resetLastBondInfo = ({ts=0} = {}) => {
    Last.reset()
    Last.set({
        ts,
        bondInfo: {},
        hasBondInfo: false,
        bondInfoStatus: Status.NULL,
        isBondRestricted: false,
    })
}

export default () => {

    const [bondInfo, setBondInfo_] = React.useState(Last.value.bondInfo || {})
    const setBondInfo = React.useCallback((bondInfo) => {
        Last.set({bondInfo})
        setBondInfo_(bondInfo)

        const { issue } = bondInfo || {}
        const { type, category } = issue || {}
        const a = ['O','R','K', 'P'].indexOf(type)>=0
            || (type==='C' && category==='N')
            || (issue && !issue.allowTrading)
        setIsBondRestricted(a)
    }, [])

    const [hasBondInfo, setHasBondInfo_] = React.useState(Last.value.hasBondInfo || false)
    const setHasBondInfo = React.useCallback((hasBondInfo) => {
        Last.set({hasBondInfo})
        setHasBondInfo_(hasBondInfo)
    }, [])

    const [bondInfoStatus, setBondInfoStatus_] = React.useState(Last.value.bondInfoStatus || Status.NULL)
    const setBondInfoStatus = React.useCallback((bondInfoStatus) => {
        Last.set({bondInfoStatus})
        setBondInfoStatus_(bondInfoStatus)
    }, [])

    const [isBondRestricted, setIsBondRestricted_] = React.useState(Last.value.isBondRestricted || false)
    const setIsBondRestricted = React.useCallback((isBondRestricted) => {
        Last.set({isBondRestricted})
        setIsBondRestricted_(isBondRestricted)
    }, [])

    const lastAbortBond = React.useRef()
    const lastAbortBook = React.useRef()
    const lastAbortEvent = React.useRef()
    const lastAbortRecent = React.useRef()

    const [bondTs, setBondTs] = React.useState(0)
    const [bondCusip, setBondCusip] = React.useState(null)

    const updateBondInfo = async ({cusip, ts, isReset}) => {

        if (!cusip) return
        if (!isReset) {
            if (bondTs && ts===bondTs) return
            if (bondInfo.cusip===cusip) return
            if (!bondTs && bondCusip === cusip) return
        }

        setBondCusip(cusip)

        if (lastAbortBond.current) { lastAbortBond.current() }
        if (lastAbortBook.current) { lastAbortBook.current() }
        if (lastAbortEvent.current) { lastAbortEvent.current() }
        if (lastAbortRecent.current) { lastAbortRecent.current() }

        try {
            setHasBondInfo(false)

            if (!cusip) {
                setBondInfoStatus(Status.NULL)
                setBondInfo({})
                return
            }

            setBondInfoStatus(Status.LOADING)

            const { data:bond_, abort:abort_bond_ } = await ajax({
                url: '/esb/retailservice/bondDetailService/getIssueDesc',
                method: 'POST',
                params: ({
                    p_cusip: cusip,
                    p_id_type: 'I',
                    p_brand: getBrand(),
                    p_alloc_id: '',
                    p_watch_id: '',
                    p_ngw: 'Y',
                })
            })

            lastAbortBond.current = abort_bond_
            const bond = await bond_
            const issue = bond.issue = bond.issue || {}
            issue.prospectus = (() => {
                const t = issue && issue.researchLinks;
                if (!t) {
                    return
                }
                if (t.indexOf('LEGAL(' + issue.cusip + ')') < 0 && t.indexOf('SALES(' + issue.cusip + ')') < 0) {
                    return
                }

                const a = t.indexOf('BDResearch.showViewer(');
                const s = t.substring(a, t.indexOf(')', a));
                const u = String(s).replace("BDResearch.showViewer('", '').replaceAll("'", '');
                const owaTcDaoContext = getOwaTcdaoContext()
                return u ? 'https://www.bonddesk.com/etrade/' + owaTcDaoContext + '/' + u : '';
            })()

            let {data:book_, abort:abort_book_} = await ajax({
                url:'/esb/portfolio/cusip/warningAndBook',
                method: 'POST',
                params: {
                    "p_criteria_fmt":"ADVANCED",
                    "p_cusip": cusip,
                    "p_maxrows":1,
                    "p_monarch":"Y",
                    "p_output_fmt":"JSON",
                    "p_multiple":["BOL-UOR","BOL-ROR"],
                    "p_submit":"JSON",
                    "p_redirect_output":"Y",
                    "p_type":"0",
                    "p_min_qty":1,
                    "p_is_offer_search":false,
                    "p_search_criteria":{},
                    "p_mode":"RP"
                }
            })
            lastAbortBook.current = abort_book_
            let book = (await book_)[0] || {}
            bond.issue.showBook = book.showBook
            bond.issue.allowTrading =  book.allowTrading
            bond.issue.warningText = book.warningText

            const { data:event_, abort:abort_event_ } = await ajax({
                url: '/esb/retailservice/bondDetailService/getSecurityEvents',
                method: 'POST',
                params: ({
                    cusip,
                    invType: bond.issue.type
                })
            })

            lastAbortEvent.current = abort_event_
            bond.events = evalJson(await event_, {}).securityeventsjson || []

            const { data:recent_, abort:abort_recent_ } = await ajax({
                url: '/esb/portfolio/trades/recent',
                method: 'GET',
                params: ({
                    cusip,
                    pageNo: 1,
                    noOfRecords: 100,
                })
            })

            const { type, category, couponTypeCode } = bond.issue || {}
            const hasTradeYield = !(
                ['P','O','R','K'].includes(type)
                || (['C','S'].includes(type) && category==='N')
                || ['E','0'].includes(couponTypeCode))

            lastAbortRecent.current = abort_recent_
            bond.recentTrades = arrayFrom((await recent_)['detailRecords'])
                .filter(({trade_date_time}) => {
                    return Date.now() - parseDate(trade_date_time) < Last30Days
                })
                .slice(0,20)
                .map(r => ({...r,  yield:hasTradeYield ? r.yield : null, }))

            setBondInfo(bond)
            setHasBondInfo(true)
            setBondInfoStatus(Status.LOADED)
            setBondTs(ts)

        } catch(e) {
            setBondInfo({})
            setHasBondInfo(false)
            setBondInfoStatus(Status.FAILED_TO_LOAD)
        }
    }

    const reset = () => {
        Last.reset()
        setHasBondInfo(false)
        clearObject(bondInfo)
        setBondInfo({})
        setBondTs(0)
    }

    return {
        bondInfo,
        setBondInfo,
        hasBondInfo,
        setHasBondInfo,
        bondInfoStatus,
        setBondInfoStatus,
        isBondRestricted,
        setBondTs,
        reset,
        updateBondInfo,
    }

}


// WEBPACK FOOTER //
// ./src/order-ticket/use-bond-info.js